export class CstIndiIncomeEntityIdDto{
    portfolioId:number;
    custId:string=""; 
   }